import React from 'react'
import { Button, Form, message, Select, Skeleton, Space } from 'antd'
import GenericList, { GenericListField } from '../../../GenericList'
import { FormComponent } from '../../../BaseComponent'
import { IntegrationFormProps } from '..'
import IIntegrationSyncSection, { syncSectionStatusValidationsMap } from '../../../../interfaces/IIntegrationSyncSection'
import { SyncSectionNameArray } from '../../../../interfaces/IIntegrationSync'
import { IntegrationConstants } from '../../../../helpers/enums/Integration'
import { UpdateSyncSectionRequest, VerifySyncSectionRequest } from '../../../../services/integration/interfaces/ApiRequest'

type IntegrationSectionsProps = IntegrationFormProps & {
  syncSections: IIntegrationSyncSection[] | null,

  loading: boolean,
  network_uuid: string,
  verifySyncSections: (args: VerifySyncSectionRequest) => Promise<any>
  updateSyncSections: (args: UpdateSyncSectionRequest) => Promise<any>
}

export default class IntegrationSections extends FormComponent<IntegrationSectionsProps> {

  state = {
    loaded: false,
    saving: false
  }

  componentDidMount() {
    const { loading, integrationUuid, verifySyncSections } = this.props

    if (!loading && integrationUuid) {
      verifySyncSections({
        network_uuid: this.props.network_uuid
      })
    }
  }

  componentDidUpdate(prevProps: IntegrationSectionsProps, prevState) {
    const wasLoading = prevProps.loading && !this.props.loading
    const wasSaving = prevState.saving && !this.state.saving
    const newState = Object.assign({}, this.state)

    if (!this.state.loaded && wasLoading) {
      newState.loaded = true

      this.setState(newState)
    }

    if (wasSaving) {
      if (this.props.error) {
        message.error(`Could not save sync sections. Reason: ${this.props.error}`)
      } else {
        message.success('Sync sections saved successfully!')
      }
    }
  }

  private processSubmit = async (sections: any[]) => {
    const { integrationUuid, updateSyncSections } = this.props
    if (!integrationUuid) return false

    for await (const payload of sections) {
      await updateSyncSections({
        network_uuid: this.props.network_uuid,
        section_name: payload.name,
        section_status: payload.status
      })
    }
  }

  private handleSave = (values: any) => {
    this.setState({
      saving: true
    }, async () => {
      await this.processSubmit(values?.sections || [])

      this.setState({
        saving: false
      })
    })
  }

  render() {
    const { syncSections } = this.props
    const { loaded, saving } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    const sectionOptions = SyncSectionNameArray.map(type => {
      return {
        label: type,
        value: type
      }
    }) as any

    const fields: GenericListField[] = [
      {
        label: 'Name',
        name: 'name',
        type: 'select',
        disabled: true,
        options: sectionOptions
      },
      {
        label: 'Status',
        name: 'status',
        type: 'select',
        render: (field, fieldName) => {
          // jeez
          const sectionIndex = fieldName[0] as unknown as number
          const section = IntegrationConstants.SYNC_SECTIONS_INITIAL_DATA[sectionIndex]
          const options = syncSectionStatusValidationsMap[section.name].map(v => ({ label: v, value: v }))

          return <Select
            allowClear={true}
            disabled={field.disabled || false}
            options={options}
          />
        },
      }
    ]

    const parsedSyncSections = IntegrationConstants.SYNC_SECTIONS_INITIAL_DATA.map(section => {
      const existing = syncSections?.find(p => p.name === section.name)
      if (existing) return existing

      return section
    })

    const values: any = {
      sections: parsedSyncSections
    }

    return (
      <Form
        name="integration_sync_sections"
        layout="vertical"
        initialValues={values}
        onFinish={this.handleSave}
      >
        <Space size="large" align="start" direction="vertical">
          <div style={{width: 360}}>
            <GenericList listName="sections" label="Sections" fields={fields} canAdd={false} canRemove={false} />
          </div>

          <Button
            type="primary"
            size="middle"
            htmlType="submit"
            loading={saving}
            block
            style={{
              width: 340
            }}
          >
            Save Sections
          </Button>
        </Space>
      </Form>
    )
  }
}
